import styled from 'styled-components'
import { VStack } from '../../../global/styles'

// eslint-disable-next-line import/prefer-default-export
export const ButtonWrapper = styled(VStack)`
  > :first-child {
    margin-bottom: 24px;
  }
`
